import HoldWrapper from '@/components/HoldWrapper';
import useUserStore from '@/stores/user.store';

/**
 * Funds that are on hold (not yet withdrawable). Rendered next to the user's
 * balance in the nav bars and under the balance in the profile modal. Only
 * shown when the backend reports a positive `balanceUsdHold`. Hovering reveals
 * the `withdrawRestrictionText` explanation via the shared HoldWrapper popover.
 */
const LockIcon = () => (
    <svg
        viewBox="0 0 24 24"
        className="w-3.5 h-3.5 shrink-0 stroke-current fill-none [stroke-width:2] [stroke-linecap:round] [stroke-linejoin:round]"
    >
        <rect x="5" y="11" width="14" height="9" rx="2" />
        <path d="M8 11V8a4 4 0 0 1 8 0v3" />
    </svg>
);

interface Props {
    /** 'pill' — compact badge for the nav bars. 'inline' — labelled badge for the profile modal. */
    variant?: 'pill' | 'inline';
}

const HoldBalance = ({ variant = 'pill' }: Props) => {
    const { user, isAuthed } = useUserStore((s) => s);
    const hold = user.balanceUsdHold ?? 0;
    if (!isAuthed || !(hold > 0)) return null;

    return (
        <HoldWrapper
            positions={['bottom', 'top']}
            text={user.withdrawRestrictionText}
            className="shrink-0 w-fit"
        >
            <span
                className={`font-chat-nick inline-flex items-center gap-1.5 rounded-fl font-extrabold tabular-nums cursor-help ${
                    variant === 'inline' ? 'px-2.5 h-7 text-[13px]' : 'px-2.5 h-9 text-[13px]'
                }`}
                style={{
                    color: '#ffb84d',
                    background: 'rgba(255,184,77,0.10)',
                    border: '1px solid rgba(255,184,77,0.34)',
                }}
            >
                <LockIcon />${hold.toFixed(2)}
                {variant === 'inline' && (
                    <span className="text-[10px] font-bold uppercase tracking-[0.08em] opacity-70">
                        on hold
                    </span>
                )}
            </span>
        </HoldWrapper>
    );
};

export default HoldBalance;
